import { render } from "./new-only-text.vue?vue&type=template&id=9d431b38&scoped=true&lang=html"
import script from "./new-only-text.vue?vue&type=script&lang=js"
export * from "./new-only-text.vue?vue&type=script&lang=js"

import "./new-only-text.vue?vue&type=style&index=0&id=9d431b38&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d431b38"]])

export default __exports__